module.exports = __webpack_public_path__ + "static/media/dinosaur(13).ff4b05b6.PNG";